import { render, staticRenderFns } from "./MovimentacaoDeVidas.vue?vue&type=template&id=2ec718cf"
import script from "./MovimentacaoDeVidas.vue?vue&type=script&lang=js"
export * from "./MovimentacaoDeVidas.vue?vue&type=script&lang=js"
import style0 from "./MovimentacaoDeVidas.vue?vue&type=style&index=0&id=2ec718cf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports